import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { fork, takeLatest, select, put } from 'redux-saga/effects';

import {
    TRACKING_LEAD_QUALITY,
    TRACKING_LEAD_QUALITY_V2
} from './IwTracking.actions';
import {
    readFromLocalStorageByKey,
    LEAD_QUALITY_STORAGE_KEY,
    writeToLocalStorageByKey,
    getStepLeadValue
} from './IwTrackingHelpers';
import { putAPI } from '../lendingAPI/lendingAPIHelpers';

export const iwTrackingSagas = [
    fork(leadQualityTrackingWorker),
    fork(leadQualityTrackingWorkerV2)
];

function* leadQualityTrackingWorker() {
    yield takeLatest(TRACKING_LEAD_QUALITY, function* ({ stepName }) {
        if (stepName === 'businessIntroduction') {
            yield put({ type: TRACKING_LEAD_QUALITY_V2 });
        }

        const qualityIndicators = yield select((state) => {
            const companyRegisteredFields = _.get(
                state,
                'form.sign_up.businessTypeFields.company.registered'
            );

            const tradingSinceDate = `${_.get(
                companyRegisteredFields,
                'mm.value'
            )}-01-${_.get(companyRegisteredFields, 'yy.value')}`;

            return {
                email: _.get(
                    state,
                    'fetched.application.payload.people[0].email'
                ),
                requestedAmount: _.get(
                    state,
                    'lendingAPI.application.data.requested_products[0].amount'
                ),
                tradingSince: tradingSinceDate,
                businessType: _.get(
                    state,
                    'form.sign_up.businessType.company.type.value'
                )
            };
        });

        const ls_allLeadValuesByStep = readFromLocalStorageByKey(
            LEAD_QUALITY_STORAGE_KEY
        );

        const currentStepLeadValue = getStepLeadValue({
            stepName: stepName,
            qualityIndicators
        });

        const ls_stepLeadValue = _.get(ls_allLeadValuesByStep, stepName);

        if (ls_stepLeadValue === currentStepLeadValue) return;

        if (ls_stepLeadValue && ls_stepLeadValue !== currentStepLeadValue) {
            GoogleTagManager.trackEvent({
                category: _.get(window, '_CUSTOMERJOURNEY'),
                event: 'Change Lead Value',
                label: `${stepName} - ${currentStepLeadValue}`
            });

            return;
        }

        writeToLocalStorageByKey(LEAD_QUALITY_STORAGE_KEY, {
            ...ls_allLeadValuesByStep,
            [stepName]: currentStepLeadValue
        });

        GoogleTagManager.trackEvent({
            category: _.get(window, '_CUSTOMERJOURNEY'),
            event: 'Track Lead Value',
            label: `${stepName} - ${currentStepLeadValue}`
        });
    });
}

function* leadQualityTrackingWorkerV2() {
    yield takeLatest(TRACKING_LEAD_QUALITY_V2, function* () {
        try {
            const result = yield putAPI({ type: 'api/GET_QUALIFIED_LEAD' });

            GoogleTagManager.trackEvent({
                category: _.get(window, '_CUSTOMERJOURNEY'),
                event: 'Track Lead Value v2',
                label: result?.payload?.qualified_lead_type
            });

            result?.payload?.qualified_lead_frameworks?.forEach((framework) => {
                GoogleTagManager.trackEvent({
                    category: _.get(window, '_CUSTOMERJOURNEY'),
                    event: `Track QLF Value ${Object.keys(framework)[0]}`,
                    label: framework[`${Object.keys(framework)[0]}`]
                });
            });
        } catch (error) {
            console.log(error);
        }
    });
}
